import React from 'react';
import { Upload } from 'antd';
import { ACCEPTED_FILE_TYPES } from '../helpers/upload.utils';

type FilePickerProps = {
  onPick: (file: File) => void;
  disabled?: boolean;
  rootClassName?: string;
  asDropzone?: boolean;
  children: React.ReactNode;
};

// antd's Upload treats a falsy beforeUpload return as "do not upload", which is
// what we want: the file is parsed in the browser and never posted as multipart.
export const FilePicker = ({
  onPick,
  disabled = false,
  rootClassName,
  asDropzone = false,
  children,
}: FilePickerProps) => {
  const Component = asDropzone ? Upload.Dragger : Upload;

  return (
    <Component
      name="file"
      accept={ACCEPTED_FILE_TYPES}
      multiple={false}
      showUploadList={false}
      disabled={disabled}
      rootClassName={rootClassName}
      beforeUpload={file => {
        onPick(file);
        return false;
      }}>
      {children}
    </Component>
  );
};
